import React, { useEffect } from 'react';
import { Helmet } from "react-helmet" ;
const Banner = () => {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'http://www.profitablecreativeformat.com/50f8aa982dcc8b0e373ef997bc5b16aa/invoke.js';
    script.async = true;
    script.setAttribute('data-at-options', JSON.stringify({
      key: '50f8aa982dcc8b0e373ef997bc5b16aa',
      format: 'iframe',
      height: 60,
      width: 468,
      params: {}
    }));

    // Append the script to the "ads" div if it exists
    const adsDiv = document.getElementById('ads');
    if (adsDiv) {
      adsDiv.appendChild(script);
    } else {
      // Handle the case where the "ads" div doesn't exist
      console.warn('The "ads" div does not exist in the DOM.');
    }

    return () => {
      // Cleanup: remove the script element when the component unmounts
      if (adsDiv) {
        adsDiv.removeChild(script);
      }
    };
  }, []);

  return (
    <div>
      <div id="ads">
        {/* Nội dung banner quảng cáo */}
      </div>
    </div>
  );
};

export default Banner;
